// Centralized Home page content for different WCHSS years.
// Keep layout/styling in components; only swap text/data here.

export const homeContent2024 = {
  banner: {
    titleTop: 'WCHSS',
    subtitleLine1: 'The 2nd World Conference on Health and',
    subtitleLine2: 'Social Sciences',
    tagline: '“Connecting People in Health and Social Sciences”',
    dateAndTime: 'October 23 – 24, 2024',
    location: 'Binawan University, Jakarta,  Indonesia',
    ctaLabel: 'Submit Now',
    ctaTo: '/registration',
  },
  welcome: {
    titleLine1: 'Welcome to The 2nd World Conference',
    titleLine2: 'on Health and Social Sciences',
    paragraphs: [
      'Join us for an enlightening exploration of the intersection between health and social sciences at Universitas Binawan. Under the theme of "Connecting People in Health and Social Sciences," this conference promises to be a platform for groundbreaking discussions, innovative ideas, and collaborative networking.',
      "Explore cutting-edge topics such as artificial intelligence (AI) in healthcare, the integration of nursing and midwifery into public health systems, and the impact of virtual reality (VR) on safety education. Whether you're a researcher, practitioner, educator, or enthusiast, WCHSS offers a unique opportunity to engage with global thought leaders and contribute to the advancement of these vital fields.",
    ],
  },
  theme: {
    heading: 'Topic',
    items: [
      'The Interconnection Between Occupational Health and Public Health: An Integrated Approach',
      'Intersections of Climate Change, Air Pollution, Public Health, and Social Life',
      'The Future of Work: AI, Precarious Employment, and Public Health',
      'AI-Driven Solutions for Excellent Service in Health, Social Innovation, and Creative Economy Sector',
      'Climate Change and Food Security: Challenges and Solutions',
      'Mental health Issues Caused by AI Utilization: AI Related Mental Health Concerns',
      'Technology Development for Public Safety',
      'Resilient Tourism: Strategies for Pandemic Preparedness and Public Health Protection',
      'Occupational Health as Part of The Environmental Responsibility of Industries',
      'Vulnerable Populations: The Impact of Air Pollution on Pregnant Women and Fetal Development',
      'Interdisciplinary Approaches to Reducing Air Pollution Exposure Among Children and Pregnant Women',
      'The Role of Occupational Health in Managing Non-Communicable Diseases (NCDs)',
      'Integrating Nursing and Midwifery Care Into Public Health System',
      'AI Innovation in Long Term Patient Care Management',
      'AI Applications to Support Clinical Laboratory Accuracy',
    ],
  },
  dates: {
    heading: 'Important Dates',
    items: [
      { date: 'July 31, 2024', label: 'Early Bird Payment Deadline' },
      { date: 'September 15, 2024', label: 'Abstract Submission Deadline' },
      { date: 'October 20, 2024', label: 'Regular Payment Deadline' },
      { date: 'October 15, 2024', label: 'Notification of Acceptances' },
      { date: 'October 23, 2024 - October 24, 2024', label: 'Conference' },
      { date: 'November 30, 2024', label: 'Full Paper Submission Deadline' },
    ],
    closingNote:
      "Mark your calendars and join us for an unforgettable experience at WCHSS. Together, let's connect, collaborate, and create a healthier, more inclusive world.",
  },
};

// NOTE: Keep 2026 dates explicit (no reuse from 2024) to avoid accidental incorrect deadlines.
export const homeContent2026 = {
  banner: {
    ...homeContent2024.banner,
    titleTop: 'WCHSS 2026',
    subtitleLine1: 'The 3rd World Conference on Health and',
    subtitleLine2: 'Social Sciences',
    tagline: '"Human Life Cycle from the Perspective of Health and Social Sciences"',
    dateAndTime: 'October 21–22, 2026',
    location: 'Binawan University, Jakarta, Indonesia',
    ctaLabel: 'Register Now',
    ctaTo: '/wchss-2026/registration',
  },
  welcome: {
    titleLine1: 'Welcome to The 3rd World Conference',
    titleLine2: 'on Health and Social Sciences',
    paragraphs: [
      'Join us for an insightful exploration of the human life cycle through the integration of health and social sciences. This conference highlights how biological, psychological, and social factors interact across different stages of life, from prenatal development to aging.',
      'With the advancement of medical science, public health, and digital health technologies, combined with the influence of social determinants such as education, culture, and policy, this conference provides a multidisciplinary platform for collaboration.',
      'WCHSS 2026 aims to foster global discussions, research dissemination, and innovation to improve quality of life and address complex health challenges across populations.',
    ],
  },
  theme: {
    heading: 'Theme & Objectives',
    items: [
      'Theme: Human Life Cycle from the Perspective of Health and Social Sciences',
      'General Objective: To facilitate global collaboration among practitioners, academics, and researchers in disseminating research-based innovations to address health and social challenges, while providing a platform for early-career researchers to publish and expand their international impact.',
      'Specific Objective: Enhance interdisciplinary understanding across biological, psychological, social, and environmental perspectives',
      'Specific Objective: Discuss health issues across the life cycle (prenatal, children, adults, elderly)',
      'Specific Objective: Identify social determinants of health',
      'Specific Objective: Promote innovation and evidence-based practice',
      'Specific Objective: Strengthen global collaboration',
      'Specific Objective: Provide policy recommendations',
      'Specific Objective: Enhance professional capacity',
    ],
  },
  speakers: [
    {
      name: 'Dr. Maria Endang Sumiwi, MPH',
      affiliation: 'Ministry of Health, Indonesia',
      topic: 'Strengthening Primary Health Systems to Enhance Community Resilience',
    },
    {
      name: 'Dr. Mrunal Shetye',
      affiliation: 'UNICEF Indonesia',
      topic: 'Physical and Psychological Health Challenges in Children and Youth',
    },
    {
      name: 'Janice Green',
      affiliation: 'ICOH, Jamaica',
      topic: 'Socioeconomic and Work-Related Determinants of Health',
    },
    {
      name: 'Hsu, Yu Yun',
      affiliation: 'NCKU Taiwan',
      topic: 'High Risk Pregnancy: Current Trend in Perinatal Care',
    },
    {
      name: 'Tiina Simola',
      affiliation: 'Finnish Union Lab',
      topic: 'Healthy Aging and Quality of Life',
    },
  ],
  dates: {
    heading: 'Important Dates',
    items: [
      { date: 'October 21–22, 2026', label: 'Conference' },
    ],
    closingNote:
      "Mark your calendars and join us for an unforgettable experience at WCHSS. Together, let's connect, collaborate, and create a healthier, more inclusive world.",
  },
};
